module.exports = __webpack_public_path__ + "static/human-heart-circle-1607f8055e77e9718cb61aec60559fcb.svg";